var bighouse = bighouse || {};

bighouse.animate = (function () {

    var lastButterfly = 0;

    var butterflies = [
        {"name" : "Butterfly--animate", "duration" : 4500},
        {"name" : "Butterfly--flutter", "duration" : 1200}

    ];

    var butterflyHovers = [
        {"name" : "Butterfly--straightflutter", "duration" : 1350},
        {"name" : "Butterfly--quickshort", "duration" : 900}
    ]; 


    function init() {

        initFooter();

        if( $('.Butterfly').length === 0 ) return;

        doAnimations(7000);
        bindHoverAnimations();
    }

    var parallaxElements, parallaxQuantity;

    function initFooter(){
        parallaxElements = $('.Footer-bg');
        parallaxQuantity = parallaxElements.length;

        setParallaxPosition();

        $(window).on('scroll', function () {
            setParallaxPosition();
        });
    }

    function setParallaxPosition(){
        window.requestAnimationFrame(function () {

            for (var i = 0; i < parallaxQuantity; i++) {

                var currentElement =  parallaxElements.eq(i);
                var scrolled = $(window).scrollTop();
                var windowHeight = $(window).height();
                var containerTop = $('.Footer').position().top;
                var speed = 0.3;
                var positionOffset = 100;

                if( scrolled >= containerTop - windowHeight - 100 ){

                    let scrollOffset = containerTop - windowHeight - 100 - scrolled;
 
                    if( currentElement[0].hasAttribute('data-speed') )
                        speed = parseFloat($(currentElement).attr('data-speed'), 10);
                    
                    if( currentElement[0].hasAttribute('data-offset') )
                        positionOffset = parseFloat($(currentElement).attr('data-offset'), 10);

                    currentElement.css({
                        'transform': 'translateY(' + (((scrollOffset * speed) - positionOffset) * -1) + 'px)'
                    });
                }

            }
        });
    }


    function doAnimations(timeout){
        setTimeout(()=>{
            generateRandomAnimation();
        }, timeout)
    }


    function generateRandomAnimation(){

        let randomAnimationIndex =  generateRandomInt(0, butterflies.length - 1);
        let randomButterlyIndex =  generateRandomInt(1, 5); 

        if(randomButterlyIndex === lastButterfly)
        randomButterlyIndex =  generateRandomInt(1, 5);  //reduce the chance of an animation applying to the previous butterfly.

        lastButterfly = randomButterlyIndex;

        applyButterflyAnimation(butterflies, randomAnimationIndex, randomButterlyIndex, true);
    }


    function bindHoverAnimations(){
        $('.Butterfly').on('mouseover', (e)=>{
            let randomAnimationIndex =  generateRandomInt(0, butterflyHovers.length - 1);
            let butterflyIndex = parseInt( $(e.currentTarget).attr('data-butterflyIndex'), 10);
            applyButterflyAnimation(butterflyHovers, randomAnimationIndex, butterflyIndex, false);
        });
    }



    function applyButterflyAnimation(animationArray, animationIndex, butterflyIndex, callback){

        //console.log('TODO: dont do animation if theres already one on the butterfly');
        var delay = animationArray[animationIndex].duration;

        //if there's no current animation the do it
        /*if( $('.Butterfly-' + butterflyIndex).attr('class').indexOf('Butterfly--') === -1 ){
            
        } else {

        }
*/

        $('.Butterfly-' + butterflyIndex).addClass( animationArray[animationIndex].name );
       
        setTimeout( () => {
            $('.Butterfly-' + butterflyIndex).removeClass( animationArray[animationIndex].name );

            if(callback){
                let newTimeout = generateRandomInt(5000, 7000);
                doAnimations(newTimeout);
            }

        }, animationArray[animationIndex].duration);
    }



    function generateRandomInt(min, max){
        return  Math.floor(Math.random() * (max - min + 1) + min);
    }

    return {
        init: init
    };
})();